import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ExclamationOutlined } from '@ant-design/icons';

import { hideUpselling } from '../../store/actions/paymentActions';

const UpsellModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const { showUpsell, upsellFrom, formCount } = useSelector((state) => state.payment);

  let message = t('billing.this-feature');

  switch (upsellFrom) {
    case 'meta':
      message = t('billing.changing-seo-meta-tags');
      break;
    case 'branding':
      message = t('billing.removing-branding');
      break;
    case 'link':
      message = t('billing.custom-link');
      break;
    case 'team':
      message = t('billing.agent-wa-routing');
      break;
    case 'fileupload':
      message = t('billing.file-upload');
      break;
    case 'formula':
      message = t('billing.formula');
      break;
    case 'section':
      message = t('billing.section');
      break;
    case 'payment':
      message = t('billing.payment');
      break;
    case 'formcount':
      message = t('billing.creating-more-forms') + ' ' + formCount + ' ' + t('billing.forms');
      break;
    case 'integrations':
      message = t('billing.custom-integrations');
      break;
    case 'domain':
      message = t('billing.custom-domain');
      break;
    case 'conditionalLogic':
      message = t('billing.conditional-logic');
      break;
    default:
      message = t('billing.this-feature');
  }

  return (
    <Modal
      title={t('billing.upgrade-your-plan')}
      icon={<ExclamationOutlined />}
      visible={showUpsell}
      onOk={() => {
        dispatch(hideUpselling());
        history.push('/billing');
      }}
      okText={t('billing.upgrade')}
      cancelText={t('common.cancel', 'Cancel')}
      onCancel={() => dispatch(hideUpselling())}
      zIndex="1001"
    >
      <b>{message}</b> {t('billing.is-not-included-in-your-plan')}
    </Modal>
  );
};

export default UpsellModal;
